/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_1_YearInputs */

const en_val_1_year = /** @type {(inputs: Val_1_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Year`)
};

const es_val_1_year = /** @type {(inputs: Val_1_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Año`)
};

const fr_val_1_year = /** @type {(inputs: Val_1_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 An`)
};

const de_val_1_year = /** @type {(inputs: Val_1_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Jahr`)
};

const ja_val_1_year = /** @type {(inputs: Val_1_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1年間`)
};

const zh_val_1_year = /** @type {(inputs: Val_1_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 年`)
};

const ar_val_1_year = /** @type {(inputs: Val_1_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنة واحدة`)
};

const id_val_1_year = /** @type {(inputs: Val_1_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Tahun`)
};

const it_val_1_year = /** @type {(inputs: Val_1_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Anno`)
};

const ru_val_1_year = /** @type {(inputs: Val_1_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Год`)
};

const pt_val_1_year = /** @type {(inputs: Val_1_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Ano`)
};

const ko_val_1_year = /** @type {(inputs: Val_1_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1년`)
};

/**
* | output |
* | --- |
* | "1 Year" |
*
* @param {Val_1_YearInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_1_year = /** @type {((inputs?: Val_1_YearInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_1_YearInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_1_year(inputs)
	if (locale === "es") return es_val_1_year(inputs)
	if (locale === "fr") return fr_val_1_year(inputs)
	if (locale === "de") return de_val_1_year(inputs)
	if (locale === "ja") return ja_val_1_year(inputs)
	if (locale === "zh") return zh_val_1_year(inputs)
	if (locale === "ar") return ar_val_1_year(inputs)
	if (locale === "id") return id_val_1_year(inputs)
	if (locale === "it") return it_val_1_year(inputs)
	if (locale === "ru") return ru_val_1_year(inputs)
	if (locale === "pt") return pt_val_1_year(inputs)
	return ko_val_1_year(inputs)
});